import { apiClientGeral, apiCallCenter } from '@/plugins/axios'

export default {
  gettarefas() {
    return apiClientGeral().get('/tarefas')
  },
  gettarefa(id) {
    return apiClientGeral().get(`/tarefas/${id}`)
  },
  posttarefa(tarefa) {
    return apiClientGeral().post('/tarefas', tarefa)
  },
  puttarefa(tarefa) {
    return apiClientGeral().put(`/tarefas/${tarefa._id}`, tarefa)
  },
  deletetarefa(id) {
    return apiClientGeral().delete(`/tarefas/${id}`)
  },
  getOperadores() {
    return apiCallCenter().get('/agent/lazy')
  },
  getOperador(id) {
    return apiCallCenter().get(`/agent/lazy/${id}`)
  },
  getrotas() {
    return apiClientGeral().get('/rotas')
  },
  getRamais() {
    return apiClientGeral().get('/ramais')
  },
  getDepartaments() {
    return apiCallCenter().get('/departamentos/lazy')
  },
  getDepartament(id) {
    return apiCallCenter().get(`/departamentos/lazy/${id}`)
  },
  getGruposDeRotas() {
    return apiClientGeral().get('/grupo-rotas')
  },
}
